import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-workflow_trigger_task",
  "use": "icon-workflow_trigger_task-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-workflow_trigger_task\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M15.07 26H7.222C5.995 26 5 25.105 5 24V6c0-1.105.995-2 2.222-2h15.556C24.005 4 25 4.895 25 6v9.018M9 10.5h12M9 17.5h6\" /><path stroke-linejoin=\"round\" d=\"M28.657 19l-7.071 7.071-4.243-4.243\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol